<template>
  <div>
    <page-header />
    <div class="upload">
      <div class="questionText">
        您正在咨询的问题
        <div class="checkOrder">{{ questionText }}</div>
      </div>
      <div class="questionText">
        <div v-show="ischeckorder">请选择您要咨询的订单</div>
        <div v-show="ischecked" class="checkOrder" @click.stop="check(true)">
          请选择您要咨询的订单
        </div>
      </div>
      <div class="orderItem" v-show="isCheck" @click.stop="check(false)">
        <div class="orderNum">
          {{ orderMessage.orderId }}
          <span
            v-if="orderMessage.activeName == 3 && orderMessage.status == 1"
            style="float:right;"
            >{{ orderMessage.winLose }}:{{ orderMessage.win }}</span
          ><span
            v-if="orderMessage.activeName == 3 && orderMessage.status == 0"
            style="float:right;"
            >未开奖</span
          >
        </div>
        <div class="ItemCont">
          <span>
            <img
              v-if="orderMessage.activeName == 1"
              class="left"
              :src="getPath(orderMessage)"
              alt=""
            />
          </span>
          <img
            class="left"
            v-if="orderMessage.activeName == 2"
            :src="getPath(orderMessage)"
            alt="订单icon"
          />
          <span v-for="item in orderStatus" :key="item.id">
            <img
              class="left"
              v-if="
                orderMessage.status == item.value &&
                  orderMessage.activeName == 3 &&
                  item.value != ''
              "
              :src="
                orderMessage.status == item.value &&
                orderMessage.activeName == 3 &&
                item.value != ''
                  ? item.src
                  : moren
              "
              alt="订单icon"
            />
          </span>
          <div class="middle">
            <span
              class="name"
              v-if="[1, 2].includes(parseInt(orderMessage.activeName, 10))"
              >{{ orderMessage.paymentName }}</span
            >

            <span class="name" v-if="orderMessage.activeName == 3">{{
              orderMessage.channelName
            }}</span>
            <span class="time" v-if="orderMessage.activeName != 3">{{
              orderMessage.createDate | customerDatetime("YYYY-MM-DD HH:mm:ss")
            }}</span>
            <span v-if="activeName == 3" class="time">{{
              orderMessage.createTime | customerDatetime("YYYY-MM-DD HH:mm:ss")
            }}</span>
          </div>
          <div class="right">
            <span
              v-if="orderMessage.status == 0 && orderMessage.activeName == 1"
              class="status"
              >充值中</span
            >
            <span
              v-if="orderMessage.status == 0 && orderMessage.activeName == 2"
              class="status"
              >提现中</span
            >
            <span
              v-if="orderMessage.status == 0 && orderMessage.activeName == 3"
              class="status"
              >未结算</span
            >
            <span
              v-else-if="
                (orderMessage.status == 1 && orderMessage.activeName == 2) ||
                  (orderMessage.status == 1 && orderMessage.activeName == 1)
              "
              class="status"
              >已完成</span
            >
            <span
              v-if="orderMessage.status == 1 && orderMessage.activeName == 3"
              class="status"
              >已结算</span
            >
            <span
              v-if="
                (orderMessage.status == 2 && orderMessage.activeName == 2) ||
                  (orderMessage.status == 2 && orderMessage.activeName == 1)
              "
              class="status"
              >失败</span
            >
            <span
              v-if="orderMessage.status == 2 && orderMessage.activeName == 3"
              class="status"
              >已取消</span
            >
            <span
              v-if="orderMessage.status == 3 && orderMessage.activeName == 3"
              class="status"
              >无效订单</span
            >
            <a
              href="javascript:void(0)"
              style="position:absolute;right:-18px;bottom:17px;font-size:12px;"
            >
              重新选择>>
            </a>
          </div>
        </div>
      </div>
      <div style="font-size:14px;color:#1e1e1e;margin-bottom:10px;clear:both;">
        上传图片
      </div>
      <el-upload
        ref="upload"
        class="upload-area"
        :class="{ hide: hideUploadEdit }"
        :action="uploadApi"
        :headers="headers"
        list-type="picture-card"
        :on-exceed="handleExceed"
        :before-upload="beforeUpload"
        :on-change="handleEditChange"
        :on-success="handleSuccess"
        :on-error="handleError"
        :on-remove="handleRemove"
        :file-list="fileList"
        :data="params"
        :limit="limit"
        name="uploadFile"
        :multiple="false"
        :drag="true"
      >
        <i class="el-icon-plus"></i>
        <div slot="file" slot-scope="{ file }">
          <img
            class="el-upload-list__item-thumbnail"
            @error="errorimg(file)"
            :src="file.url"
            alt=""
          />
          <i class="el-icon-error" @click="handleRemove(file)"></i>
          <div v-if="file.status == 'success'" class="tip">上传成功</div>
          <div v-if="file.status == 'uploading'" class="tip">上传中</div>
        </div>
      </el-upload>
      <div style="color:red;margin-top:10px;line-height:1.5">
        提示：请上传相关图片，可帮助客服更快速处理您的问题
      </div>
      <div
        v-if="buttonDisablie"
        class="primary-btn"
        @click="toMessage"
        :class="{ disabled: isUpload }"
      >
        完成，进入客服
      </div>
      <div v-if="!buttonDisablie" class="primary-btn" @click="jump">
        跳过，直接进入会话
      </div>
    </div>
    <order-list
      :direction="direction"
      @dialogHide="dialogHide"
      @checkOrder="checkOrder"
      v-if="listStatus"
      ref="orderList"
    />
    <uploadimg-success-loading v-if="loading" />
  </div>
</template>

<script>
import transferUploadImg from "src/mixins/transferUploadImg";
import uploadimgSuccessLoading from "../components/uploadimg-success-loading";
import orderList from "src/app/customer/components/orderList";
import pageHeader from "../components/page-header";
import { forbidMoveLeft } from "../../utils";
import constant from "../../constant";

import { getOrderPath } from "../../utils/imgs";

export default {
  name: "upLoadImg",
  mixins: [transferUploadImg],
  components: { uploadimgSuccessLoading, pageHeader, orderList },
  data() {
    return {
      loading: false, //显示loaning遮罩层
      hideUploadEdit: false,
      direction: "btt",
      isCheck: false, //是否选中订单
      ischeckorder: false,
      ischecked: false,
      orderMessage: {},
      queryOrderType: null,
      moren: require("src/assets/imgs/moren.png"),
      orderStatus: [
        {
          id: "1",
          value: "",
          label: "全部"
        },
        {
          id: "2",
          value: "0",
          label: "未结算",
          src: require("src/assets/imgs/quxiao.png")
        },
        {
          id: "3",
          value: "1",
          label: "成功",
          src: require("src/assets/imgs/success.png")
        },
        {
          id: "4",
          value: "2",
          label: "失败",
          src: require("src/assets/imgs/shibai.png")
        },
        {
          id: "5",
          value: "3",
          label: "无效订单",
          src: require("src/assets/imgs/wuxiao.png")
        }
      ]
    };
  },
  computed: {
    ...mapState({
      questionText: state => state.questionText,
      chatType: state => state.chatType,
      skillType: state => state.skillType,
      orderNum: state => state.orderNum,
      listStatus: state => state.listStatus,
      activeName: state => state.activeName,
      payoption: state => state.rechargeListResult,
      isSpecialScenes: state => state.isSpecialScenes
    })
  },
  mounted() {
    if (this.isSpecialScenes === true) {
      this.jump();
    } else {
      this.$store.dispatch("getRechargeListResult");
    }
  },
  created() {
    forbidMoveLeft();
    let skillName = this.skillType.toString();
    this.$store.commit("setState", {
      activeName: skillName
    });
    switch (skillName) {
      case constant.skillName.NotReceived:
      case constant.skillName.Reflect:
      case constant.skillName.Game:
        this.ischeckorder = true;
        this.ischecked = true;
        break;

      default:
        this.ischeckorder = false;
        this.ischecked = false;
        break;
    }
  },
  methods: {
    // 获取对应的icon图标
    getPath(item) {
      if (item.iconPath) {
        return item.iconPath;
      } else {
        return require("src/assets/imgs/moren.png");
      }
    },
    getOrderPath,
    check(isreset) {
      this.$store.commit("setState", { listStatus: true });
      let skillName = this.skillType.toString();
      this.$store.commit("setState", {
        activeName: skillName
      });
      switch (skillName) {
        case constant.skillName.NotReceived:
        case constant.skillName.Reflect:
        case constant.skillName.Game:
          if (isreset) {
            this.ischeckorder = true;
            this.ischecked = true;
          } else {
            this.ischeckorder = true;
            this.ischecked = false;
          }
          this.$store.commit("setState", {
            activeName: this.skillType.toString()
          });
          break;

        default:
          this.ischeckorder = false;
          break;
      }
      // this.$refs.orderList.clearData();
      // this.$refs.orderList.getData();
    },
    dialogHide() {
      this.$store.commit("setState", { listStatus: false });
    },
    checkOrder(item) {
      // console.log(item);
      this.queryOrderType = parseInt(item.item.activeName);
      this.orderMessage = item.item;
      this.isUpload = false;
      this.ischeckorder = true;
      this.ischecked = false;
      this.isCheck = true;
    },
    changetab(activeName) {
      this.$store.commit("setState", {
        listStatus: true,
        activeName: activeName
      });
    },
    ...mapActions({
      initChannel: "initChannel"
    }),
    errorimg(file) {
      this.$message.error("文件无效（0kb）或格式不正确，请重新选择正确文件");
      this.handleRemove(file);
      this.isUpload = false;
      this.fileList.forEach(element => {
        if (element.status != "success") {
          this.isUpload = true;
          return false;
        }
      });
    },
    removeImg() {
      clearTimeout(this.time);
      this.time = setTimeout(() => {
        this.hideUploadEdit = this.fileList.length >= this.limit;
      }, 500);
    },
    handleEditChange(file, fileList) {
      this.fileList = fileList;
      console.log(file, fileList, fileList.length);
      this.hideUploadEdit = fileList.length >= this.limit;
    },
    toMessage() {
      if (this.buttonDisablie && !this.isUpload) {
        this.loading = true;
        let orderImgUrls = [];
        Object.keys(this.listObj).forEach(index => {
          orderImgUrls.push(this.listObj[index]);
        });
        orderImgUrls = orderImgUrls.join(",");
        let orderNum = this.orderMessage.orderId
          ? this.orderMessage.orderId
          : "";
        this.$store.commit("setState", {
          isUploadImg: false,
          orderImgUrls,
          isBeforeConnect: false,
          isJump: true,
          orderNum
        });

        this.$refs.upload.submit();
        this.initChannel({
          orderImgUrls,
          queryOrderType: this.queryOrderType,
          router: this.$router
        }).catch(() => {
          this.loading = false;
        });
        // this.$router.push("/conversation");
      }
    },
    jump() {
      this.loading = true;
      let orderImgUrls = [];
      let orderNum = this.orderMessage.orderId ? this.orderMessage.orderId : "";
      Object.keys(this.listObj).forEach(index => {
        orderImgUrls.push(this.listObj[index]);
      });

      orderImgUrls = orderImgUrls.join(",");
      this.$store.commit("setState", {
        isUploadImg: false,
        orderImgUrls,
        isBeforeConnect: false,
        isJump: true,
        orderNum,
        queryOrderType: this.queryOrderType
      });

      this.$refs.upload.submit();
      this.initChannel({ orderImgUrls: "", router: this.$router }).catch(() => {
        this.loading = false;
      });
      // this.$router.push("/conversation");
    }
  }
};
</script>
<style lang="less" scoped>
.orderItem {
  height: 106px;
  position: relative;
  border-bottom: 1px dashed #e5e5e5;
  .orderNum {
    padding: 10px;
    font-size: 14px;
    background: rgba(242, 242, 242, 1);
  }
  .ItemCont {
    background: rgba(242, 242, 242, 1);
    height: 70px;
    padding: 10px;
    font-size: 14px;
    .left {
      float: left;
      width: 50px;
      height: 50px;
    }
    .middle {
      float: left;
      width: 45%;
      height: 70px;
      position: relative;
      .name {
        position: absolute;
        left: 5px;
        top: 5px;
      }
      .time {
        position: absolute;
        left: 5px;
        top: 25px;
        font-size: 13px;
      }
    }
    .right {
      width: 30%;
      float: left;
      height: 70px;
      position: relative;
      .prince {
        position: absolute;
        right: 5px;
        top: 5px;
      }
      .status {
        position: absolute;
        right: 5px;
        top: 22px;
      }
    }
  }
}
.checkOrder {
  height: 45px;
  line-height: 45px;
  text-align: center;
  background: #e5e5e5;
  margin-top: 5px;
  border-radius: 5px;
}
.tip {
  color: #67c23a;
  z-index: 64;
  position: absolute;
  top: 75px;
  width: 100%;
  text-align: center;
  background: rgba(0, 0, 0, 0.8);
  color: #fff;
}
.el-icon-error {
  font-size: 20px;
  position: absolute;
  z-index: 66;
  right: 0;
  top: 0;
  color: red;
}
.upload {
  width: 316px;
  margin: 80px auto 0;

  .questionText {
    font-size: 14px;
    line-height: 20px;
    padding-bottom: 20px;
  }

  .primary-btn {
    height: 44px;
    margin: 30px auto 20px;
    font-size: 16px;
    line-height: 44px;
    border-radius: 2px;
    text-align: center;
    background: var(--button-bg) !important;
    color: #fff;
    &:active {
      background: var(--button-click) !important;
      color: var(--button-text-click) !important;
    }
  }

  .disabled {
    opacity: 0.4;
  }

  .skip {
    display: inline-block;
    width: 100%;
    height: 22px;
    line-height: 22px;
    font-size: 16px;
    text-align: center;
    color: var(--loaddimg-tiaoguo-text);
    &:active {
      color: var(--loaddimg-tiaoguo-click);
    }
  }

  /deep/ .el-upload {
    display: inline-flex;
    width: 99px;
    height: 99px;
    justify-content: center;
    align-items: center;

    .el-icon-plus {
      color: var(--loadimg-add-icon);
      &:active {
        color: var(--loadimg-add-click);
      }
    }
  }

  /deep/ .el-upload-list__item {
    width: 99px;
    height: 99px;
    position: relative;
    img {
      max-width: 100%;
      height: auto;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      margin: auto;
    }
    &:nth-of-type(3n) {
      margin-right: 0;
    }
  }

  /deep/ .el-upload--picture-card {
    border: 0px dashed var(--loadimg-add-icon);
    border-color: var(--loadimg-add-icon);
    &:active {
      border-color: var(--loadimg-add-click);
    }
    .el-upload-dragger {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}
</style>
